import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faCheck } from '@fortawesome/free-solid-svg-icons';
import { getBankColor } from '../../utils/formatters';

const PaymentItem = ({ payment }) => {
  const airtableLink = `https://airtable.com/app7XWoxwjvdzoSQ1/tblizR9cNHkgtCWs9/viwd5cQN4YM0jc7N7/${payment.id}?blocks=hide`;
  let details = [];
  
  // Bank badge
  let bankBadge = null;
  if (payment.banque) {
    const bankColor = getBankColor(payment.banque);
    bankBadge = (
      <span 
        className="bank-badge" 
        style={{ backgroundColor: bankColor.bg, color: bankColor.text }}>
        {payment.banque}
      </span>
    );
  }
  
  // Version badge
  let versionBadge = null;
  if (payment.version === 'v2') {
    versionBadge = <span className="version-badge v2-badge">V2</span>;
  } else {
    versionBadge = <span className="version-badge regular-badge">Standard</span>;
  }
  
  // Payment details
  if (payment.transactionId) {
    const isManual = payment.transactionId.toLowerCase().includes('payé cash') || 
                    payment.banque === 'manuel' ||
                    payment.transactionId.toLowerCase().includes('manuel');
    
    details.push(isManual 
      ? <strong style={{ color: '#8b5cf6' }}>ID: {payment.transactionId}</strong>
      : `ID: ${payment.transactionId}`);
  }
  
  if (payment.label) details.push(`Label: ${payment.label}`);
  if (payment.reference && payment.reference !== payment.label) details.push(`Réf: ${payment.reference}`);
  if (payment.type !== 'loyer') details.push(payment.type.replace(/[()]/g, ''));
  if (payment.side === 'debit') details.push(<span className="negative">REMBOURSEMENT</span>);
  
  const remboursementStyle = payment.side === 'debit' ? { color: '#dc2626', fontWeight: '600' } : {};
  
  return (
    <div>
      <a 
        href={airtableLink} 
        target="_blank" 
        className="payment-link" 
        style={remboursementStyle}
        rel="noopener noreferrer">
        {payment.date}: {payment.amount}€ <FontAwesomeIcon icon={faLink} className="link-icon" />
      </a>
      {bankBadge}
      {versionBadge}
      
      {details.length > 0 && (
        <div className="payment-details">
          {details.map((detail, index) => (
            <React.Fragment key={index}>
              {index > 0 && " | "}
              {detail}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default PaymentItem;
